import { getCurrentLocale, type AppLocale } from './index'

type Translation = Partial<Record<AppLocale, string>>
type PatternRule = { match: RegExp; render: (term: string) => string }

// Plain term dictionary.  Add new locales here.
const termMap: Record<string, Translation> = {
  '账号': { 'en-US': 'Account' },
  '账号信息': { 'en-US': 'Account Info' },
  '账号列表': { 'en-US': 'Account List' },
  '账号状态': { 'en-US': 'Account Status' },
  '操作': { 'en-US': 'Actions' },
  '操作日志': { 'en-US': 'Operation Logs' },
  '操作时间': { 'en-US': 'Operation Time' },
  '访问码': { 'en-US': 'Access Code' },
  '访问地址': { 'en-US': 'Access URL' },
  '访问路由地址': { 'en-US': 'Route Path' },
  '版本': { 'en-US': 'Version' },
  '保存': { 'en-US': 'Save' },
  '保存配置': { 'en-US': 'Save Settings' },
  '备注': { 'en-US': 'Remark' },
  '编辑': { 'en-US': 'Edit' },
  '编辑设备': { 'en-US': 'Edit Device' },
  '编辑时间': { 'en-US': 'Edited At' },
  '标题': { 'en-US': 'Title' },
  '语种': { 'en-US': 'Language' },
  '表单构建': { 'en-US': 'Form Builder' },
  '参数键名': { 'en-US': 'Parameter Key' },
  '参数键值': { 'en-US': 'Parameter Value' },
  '参数名称': { 'en-US': 'Parameter Name' },
  '参数设置': { 'en-US': 'Parameter Settings' },
  '查询': { 'en-US': 'Query' },
  '查看': { 'en-US': 'View' },
  '查看密码': { 'en-US': 'View Password' },
  '查看设备': { 'en-US': 'View Device' },
  '详情': { 'en-US': 'Details' },
  '成功': { 'en-US': 'Success' },
  '创建时间': { 'en-US': 'Created At' },
  '确认': { 'en-US': 'Confirm' },
  '确定': { 'en-US': 'Confirm' },
  '取消': { 'en-US': 'Cancel' },
  '删除': { 'en-US': 'Delete' },
  '删除成功': { 'en-US': 'Deleted successfully' },
  '菜单': { 'en-US': 'Menu' },
  '菜单名称': { 'en-US': 'Menu Name' },
  '菜单状态': { 'en-US': 'Menu Status' },
  '菜单类型': { 'en-US': 'Menu Type' },
  '菜单图标': { 'en-US': 'Menu Icon' },
  '菜单管理': { 'en-US': 'Menu Management' },
  '菜单顺序': { 'en-US': 'Menu Order' },
  '代码生成': { 'en-US': 'Code Generator' },
  '单条强退': { 'en-US': 'Force Logout' },
  '登录': { 'en-US': 'Login' },
  '登录地址': { 'en-US': 'Login Address' },
  '登录账号': { 'en-US': 'Login Account' },
  '登录地点': { 'en-US': 'Login Location' },
  '登录日志': { 'en-US': 'Login Logs' },
  '登录时间': { 'en-US': 'Login Time' },
  '登录状态': { 'en-US': 'Login Status' },
  '递增': { 'en-US': 'Ascending' },
  '地址': { 'en-US': 'Address' },
  '地区': { 'en-US': 'Region' },
  '字典编码': { 'en-US': 'Dictionary Code' },
  '字典标签': { 'en-US': 'Dictionary Label' },
  '字典键值': { 'en-US': 'Dictionary Value' },
  '字典名称': { 'en-US': 'Dictionary Name' },
  '字典排序': { 'en-US': 'Dictionary Order' },
  '字典类型': { 'en-US': 'Dictionary Type' },
  '字典管理': { 'en-US': 'Dictionary Management' },
  '字典数据': { 'en-US': 'Dictionary Data' },
  '状态': { 'en-US': 'Status' },
  '设备': { 'en-US': 'Device' },
  '设备IP': { 'en-US': 'Device IP' },
  '设备IP地址': { 'en-US': 'Device IP Address' },
  '设备列表': { 'en-US': 'Device List' },
  '设备名称': { 'en-US': 'Device Name' },
  '设备品牌': { 'en-US': 'Device Brand' },
  '设备型号': { 'en-US': 'Device Model' },
  '设备序列号': { 'en-US': 'Device Serial No.' },
  '设备状态': { 'en-US': 'Device Status' },
  '设备资产码': { 'en-US': 'Device Asset No.' },
  '设备管理': { 'en-US': 'Device Management' },
  '设备详情': { 'en-US': 'Device Details' },
  '角色': { 'en-US': 'Role' },
  '角色编号': { 'en-US': 'Role ID' },
  '角色名称': { 'en-US': 'Role Name' },
  '角色权限': { 'en-US': 'Role Permission' },
  '角色顺序': { 'en-US': 'Role Order' },
  '角色管理': { 'en-US': 'Role Management' },
  '分配机构': { 'en-US': 'Assigned Organization' },
  '分配角色': { 'en-US': 'Assign Roles' },
  '分配用户': { 'en-US': 'Assign Users' },
  '分配状态': { 'en-US': 'Assignment Status' },
  '分类名称': { 'en-US': 'Category Name' },
  '分类导航': { 'en-US': 'Category Navigation' },
  '分类图标': { 'en-US': 'Category Icon' },
  '分页': { 'en-US': 'Pagination' },
  '服务监控': { 'en-US': 'Server Monitor' },
  '更新': { 'en-US': 'Update' },
  '更新成功': { 'en-US': 'Updated successfully' },
  '修改': { 'en-US': 'Edit' },
  '修改成功': { 'en-US': 'Updated successfully' },
  '修改时间': { 'en-US': 'Updated At' },
  '功能': { 'en-US': 'Feature' },
  '功能列表': { 'en-US': 'Feature List' },
  '功能名称': { 'en-US': 'Feature Name' },
  '功能详情': { 'en-US': 'Feature Details' },
  '公告': { 'en-US': 'Notice' },
  '公告标题': { 'en-US': 'Notice Title' },
  '公告类型': { 'en-US': 'Notice Type' },
  '公告内容': { 'en-US': 'Notice Content' },
  '公告状态': { 'en-US': 'Notice Status' },
  '关键字': { 'en-US': 'Keyword' },
  '关闭': { 'en-US': 'Close' },
  '管理员': { 'en-US': 'Administrator' },
  '规格1': { 'en-US': 'Spec 1' },
  '规格2': { 'en-US': 'Spec 2' },
  '国际化Key': { 'en-US': 'I18n Key' },
  '机构': { 'en-US': 'Institution' },
  '机构名称': { 'en-US': 'Institution Name' },
  '机构列表': { 'en-US': 'Institution List' },
  '机构详情': { 'en-US': 'Institution Details' },
  '机构管理': { 'en-US': 'Institution Management' },
  '缓存监控': { 'en-US': 'Cache Monitor' },
  '缓存列表': { 'en-US': 'Cache List' },
  '角色列表': { 'en-US': 'Role List' },
  '教室': { 'en-US': 'Classroom' },
  '教室管理': { 'en-US': 'Classroom Management' },
  '教室列表': { 'en-US': 'Classroom List' },
  '教室名称': { 'en-US': 'Classroom Name' },
  '教室房间': { 'en-US': 'Classroom Room' },
  '教室·座位号': { 'en-US': 'Classroom / Seat' },
  '结束日期': { 'en-US': 'End Date' },
  '结束时间': { 'en-US': 'End Time' },
  '开始日期': { 'en-US': 'Start Date' },
  '开始时间': { 'en-US': 'Start Time' },
  '开启': { 'en-US': 'Enable' },
  '禁用': { 'en-US': 'Disabled' },
  '启用': { 'en-US': 'Enabled' },
  '离线': { 'en-US': 'Offline' },
  '在线': { 'en-US': 'Online' },
  '已分配': { 'en-US': 'Allocated' },
  '未分配': { 'en-US': 'Unallocated' },
  '连接状态': { 'en-US': 'Connection' },
  '类型': { 'en-US': 'Type' },
  '列表': { 'en-US': 'List' },
  '名称': { 'en-US': 'Name' },
  '排序': { 'en-US': 'Order' },
  '排课中心': { 'en-US': 'Scheduling Center' },
  '品牌': { 'en-US': 'Brand' },
  '配图': { 'en-US': 'Image' },
  '权限': { 'en-US': 'Permission' },
  '权限标识': { 'en-US': 'Permission' },
  '权限字符': { 'en-US': 'Permission' },
  '全部': { 'en-US': 'All' },
  '日志': { 'en-US': 'Logs' },
  '日志管理': { 'en-US': 'Log Management' },
  '删除后设备将无法恢复，请谨慎处理。': { 'en-US': 'This device cannot be recovered after deletion. Please proceed with caution.' },
  '上传': { 'en-US': 'Upload' },
  '上传图片': { 'en-US': 'Upload Image' },
  '上级菜单': { 'en-US': 'Parent Menu' },
  '生成代码': { 'en-US': 'Generate Code' },
  '时间': { 'en-US': 'Time' },
  '是否缓存': { 'en-US': 'Cache' },
  '是否外链': { 'en-US': 'External Link' },
  '显示排序': { 'en-US': 'Display Order' },
  '显示状态': { 'en-US': 'Visible' },
  '数据监控': { 'en-US': 'Data Monitor' },
  '数据权限': { 'en-US': 'Data Scope' },
  '搜索': { 'en-US': 'Search' },
  '所属机构': { 'en-US': 'Organization' },
  '提示': { 'en-US': 'Prompt' },
  '停用': { 'en-US': 'Disabled' },
  '通知公告': { 'en-US': 'Notice' },
  '图标': { 'en-US': 'Icon' },
  '外链': { 'en-US': 'External Link' },
  '新增': { 'en-US': 'Add' },
  '新增设备': { 'en-US': 'Add Device' },
  '新增成功': { 'en-US': 'Created successfully' },
  '序列号': { 'en-US': 'Serial No.' },
  '序号': { 'en-US': 'No.' },
  '学员': { 'en-US': 'Student' },
  '学员列表': { 'en-US': 'Cadet List' },
  '压缩': { 'en-US': 'Compress' },
  '音效列表': { 'en-US': 'Sound List' },
  '音乐资源库': { 'en-US': 'Music Library' },
  '应用列表': { 'en-US': 'Application List' },
  '应用名称': { 'en-US': 'Application Name' },
  '应用详情': { 'en-US': 'Application Details' },
  '用户': { 'en-US': 'User' },
  '用户编号': { 'en-US': 'User ID' },
  '用户名称': { 'en-US': 'User Name' },
  '用户昵称': { 'en-US': 'Nickname' },
  '用户管理': { 'en-US': 'User Management' },
  '邮箱': { 'en-US': 'Email' },
  '运营管理': { 'en-US': 'Operation Management' },
  '资源库': { 'en-US': 'Resource Library' },
  '重置': { 'en-US': 'Reset' },
  '重置密码': { 'en-US': 'Reset Password' },
  '组件路径': { 'en-US': 'Component Path' },
  '最大高度': { 'en-US': 'Max Height' },
  '课包分类': { 'en-US': 'Package Category' },
  '课包列表': { 'en-US': 'Package List' },
  '课件分类': { 'en-US': 'Courseware Category' },
  '课件列表': { 'en-US': 'Courseware List' },
  '课程记录': { 'en-US': 'Course Records' },
  '课程管理': { 'en-US': 'Course Management' },
  '课程名称': { 'en-US': 'Course Name' },
  '课程详情': { 'en-US': 'Course Details' },
  '机构ID': { 'en-US': 'Institution ID' },
  '机构 ID': { 'en-US': 'Institution ID' },
  '机构负责人': { 'en-US': 'Institution Owner' },
  '机构分管人': { 'en-US': 'Institution Manager' },
  '机构邮箱': { 'en-US': 'Institution Email' },
  '机构账号': { 'en-US': 'Institution Account' },
  '机构类型': { 'en-US': 'Institution Type' },
  '机构算力': { 'en-US': 'Institution Credits' },
  '机构管理员': { 'en-US': 'Institution Admin' },
  '添加机构': { 'en-US': 'Add Institution' },
  '查看详情': { 'en-US': 'View Details' },
  '剩余算力': { 'en-US': 'Remaining Credits' },
  '消耗算力': { 'en-US': 'Consumed Credits' },
  '剩余算力/消耗算力': { 'en-US': 'Remaining / Consumed Credits' },
  '累计剩余算力': { 'en-US': 'Total Remaining Credits' },
  '累计消耗算力': { 'en-US': 'Total Consumed Credits' },
  '负责人姓名': { 'en-US': 'Owner Name' },
  '姓名': { 'en-US': 'Name' },
  '职位': { 'en-US': 'Position' },
  '电话': { 'en-US': 'Phone' },
  '手机号': { 'en-US': 'Mobile' },
  '手机号码': { 'en-US': 'Mobile' },
  '微信': { 'en-US': 'WeChat' },
  '基础信息': { 'en-US': 'Basic Info' },
  '后台账号信息': { 'en-US': 'Backend Account Info' },
  '客户端账号信息': { 'en-US': 'Client Account Info' },
  '客户端账号状态': { 'en-US': 'Client Account Status' },
  '老师列表': { 'en-US': 'Teacher List' },
  '老师详情': { 'en-US': 'Teacher Details' },
  '新增老师': { 'en-US': 'Add Teacher' },
  '学员姓名': { 'en-US': 'Cadet Name' },
  '学员头像': { 'en-US': 'Cadet Avatar' },
  '学员年龄': { 'en-US': 'Cadet Age' },
  '学员性别': { 'en-US': 'Cadet Gender' },
  '学员电话': { 'en-US': 'Cadet Phone' },
  '学员微信': { 'en-US': 'Cadet WeChat' },
  '学员身份': { 'en-US': 'Cadet Identity' },
  '批量导入学员': { 'en-US': 'Batch Import Cadets' },
  '下载模板': { 'en-US': 'Download Template' },
  '导入': { 'en-US': 'Import' },
  '导出': { 'en-US': 'Export' },
  '正式身份': { 'en-US': 'Official' },
  '临时身份': { 'en-US': 'Temporary' },
  '添加教室': { 'en-US': 'Add Classroom' },
  '教室编号': { 'en-US': 'Classroom ID' },
  '教室内的设备': { 'en-US': 'Classroom Devices' },
  '教室成员': { 'en-US': 'Classroom Members' },
  '成员身份': { 'en-US': 'Member Role' },
  '是否为主机': { 'en-US': 'Primary Device' },
  '上课时间': { 'en-US': 'Class Time' },
  '上课老师': { 'en-US': 'Teacher' },
  '上课教室': { 'en-US': 'Classroom' },
  '上课班级': { 'en-US': 'Class' },
  '全部课程': { 'en-US': 'All Courses' },
  '全部老师': { 'en-US': 'All Teachers' },
  '全部教室': { 'en-US': 'All Classrooms' },
  '全部班级': { 'en-US': 'All Classes' },
  '查看课堂文件': { 'en-US': 'View Class Files' },
  '批量下载': { 'en-US': 'Batch Download' },
  '暂无图片资源': { 'en-US': 'No image resources' },
  '暂无视频资源': { 'en-US': 'No video resources' },
  '暂无音频资源': { 'en-US': 'No audio resources' },
  '图片加载失败': { 'en-US': 'Image failed to load' },
  '暂不支持该类型的预览': { 'en-US': 'Preview is not supported for this type' },
  '音乐试听': { 'en-US': 'Music Preview' },
  '下载作品集': { 'en-US': 'Download Portfolio' },
  '下载模型': { 'en-US': 'Download Model' },
  '关联应用': { 'en-US': 'Linked Application' },
  '关联课件': { 'en-US': 'Linked Courseware' },
  '关联课包': { 'en-US': 'Linked Package' },
  '关联课件数量': { 'en-US': 'Linked Courseware Count' },
  '关联课包数量': { 'en-US': 'Linked Package Count' },
  '查看关联课件': { 'en-US': 'View Linked Courseware' },
  '查看关联课包': { 'en-US': 'View Linked Packages' },
  '查看关联一级分类': { 'en-US': 'View Linked Level 1 Categories' },
  '查看关联二级分类': { 'en-US': 'View Linked Level 2 Categories' },
  '一级分类ID': { 'en-US': 'Level 1 Category ID' },
  '一级分类名称': { 'en-US': 'Level 1 Category Name' },
  '一级分类封面': { 'en-US': 'Level 1 Category Cover' },
  '一级分类状态': { 'en-US': 'Level 1 Category Status' },
  '一级分类简介': { 'en-US': 'Level 1 Category Description' },
  '二级分类ID': { 'en-US': 'Level 2 Category ID' },
  '二级分类名称': { 'en-US': 'Level 2 Category Name' },
  '二级分类封面': { 'en-US': 'Level 2 Category Cover' },
  '二级分类状态': { 'en-US': 'Level 2 Category Status' },
  '二级分类简介': { 'en-US': 'Level 2 Category Description' },
  '所属一级分类': { 'en-US': 'Parent Level 1 Category' },
  '所属课包分类': { 'en-US': 'Package Category' },
  '新增一级分类': { 'en-US': 'Add Level 1 Category' },
  '新增二级分类': { 'en-US': 'Add Level 2 Category' },
  '新增课件分类': { 'en-US': 'Add Courseware Category' },
  '新增课包分类': { 'en-US': 'Add Package Category' },
  '分类排序': { 'en-US': 'Category Order' },
  '分类状态': { 'en-US': 'Category Status' },
  '应用介绍': { 'en-US': 'Application Description' },
  '应用分类': { 'en-US': 'Application Category' },
  '应用封面图': { 'en-US': 'Application Cover' },
  '应用状态': { 'en-US': 'Application Status' },
  '应用类型': { 'en-US': 'Application Type' },
  '官方提供': { 'en-US': 'Officially Provided' },
  '课件名称': { 'en-US': 'Courseware Name' },
  '课包名称': { 'en-US': 'Package Name' },
  '课件应用': { 'en-US': 'Courseware Application' },
  '课包内课件': { 'en-US': 'Courseware in Package' },
  '创建课件': { 'en-US': 'Create Courseware' },
  '创建课包': { 'en-US': 'Create Package' },
  '复制并创建': { 'en-US': 'Copy and Create' },
  '复制并创建课件': { 'en-US': 'Copy and Create Courseware' },
  'AI制作课件': { 'en-US': 'AI Courseware' },
  '数据总览': { 'en-US': 'Data Overview' },
  '活跃功能': { 'en-US': 'Active Features' },
  '功能ID': { 'en-US': 'Feature ID' },
  '功能分类': { 'en-US': 'Feature Category' },
  '功能排序': { 'en-US': 'Feature Order' },
  '功能状态': { 'en-US': 'Feature Status' },
  '功能模版': { 'en-US': 'Feature Template' },
  '功能调用次数': { 'en-US': 'Feature Calls' },
  '新增功能': { 'en-US': 'Add Feature' },
  '上传音乐': { 'en-US': 'Upload Music' },
  '上传配乐': { 'en-US': 'Upload Soundtrack' },
  '发布时间': { 'en-US': 'Publish Time' },
  '定时发布': { 'en-US': 'Scheduled Publish' },
  '立即发布': { 'en-US': 'Publish Now' },
  'banner图': { 'en-US': 'Banner Image' },
  'banner封面图': { 'en-US': 'Banner Cover' },
  'Banner详情': { 'en-US': 'Banner Details' },
  '跳转链接': { 'en-US': 'Jump Link' },
  '排名': { 'en-US': 'Rank' },
  '总消耗': { 'en-US': 'Total Consumption' },
  '总消耗（算力）': { 'en-US': 'Total Consumption (Credits)' },
  '总费用（算力）': { 'en-US': 'Total Cost (Credits)' },
  '算力数量': { 'en-US': 'Credits' },
  '算力明细': { 'en-US': 'Credit Details' },
  '算力消耗': { 'en-US': 'Credit Consumption' },
  '算力消耗趋势': { 'en-US': 'Credit Consumption Trend' },
  '新增算力数': { 'en-US': 'Added Credits' },
  '新增算力说明': { 'en-US': 'Credit Description' },
  '添加算力': { 'en-US': 'Add Credits' },
  '消耗': { 'en-US': 'Consumption' },
  '消耗数量': { 'en-US': 'Consumption Amount' },
  '消耗类型': { 'en-US': 'Consumption Type' },
  '充值时间': { 'en-US': 'Recharge Time' },
  '原密码': { 'en-US': 'Old Password' },
  '新密码': { 'en-US': 'New Password' },
  '修改密码': { 'en-US': 'Change Password' },
  '选择角色': { 'en-US': 'Select Role' },
  '默认为机构邮箱': { 'en-US': 'Defaults to institution email' },
  '打印尺寸': { 'en-US': 'Print Size' },
  '打印尺寸(cm)': { 'en-US': 'Print Size (cm)' },
  '工作台': { 'en-US': 'Workbench' },
  'AI智能数量': { 'en-US': 'AI Agent Count' },
  '较昨日': { 'en-US': 'vs Yesterday' },
  '剩余算力预估使用时长（天）': { 'en-US': 'Estimated Remaining Compute Duration (Days)' },
  '不显示': { 'en-US': 'Hidden' },
  '显示': { 'en-US': 'Visible' },
  '隐藏': { 'en-US': 'Hidden' },
  '正常': { 'en-US': 'Normal' },
  '是': { 'en-US': 'Yes' },
  '否': { 'en-US': 'No' },
  '目录': { 'en-US': 'Directory' },
  '按钮': { 'en-US': 'Button' },
  '缓存': { 'en-US': 'Cache' },
  '不缓存': { 'en-US': 'No Cache' },
  '添加菜单': { 'en-US': 'Add Menu' },
  '修改菜单': { 'en-US': 'Edit Menu' },
  '添加用户': { 'en-US': 'Add User' },
  '修改用户': { 'en-US': 'Edit User' },
  '添加角色': { 'en-US': 'Add Role' },
  '修改角色': { 'en-US': 'Edit Role' },
  '分配数据权限': { 'en-US': 'Assign Data Permissions' },
  '添加字典类型': { 'en-US': 'Add Dictionary Type' },
  '修改字典类型': { 'en-US': 'Edit Dictionary Type' },
  '添加部门': { 'en-US': 'Add Department' },
  '修改部门': { 'en-US': 'Edit Department' },
  '新增学员': { 'en-US': 'Add Cadet' },
  '编辑学员': { 'en-US': 'Edit Cadet' },
  '添加学员': { 'en-US': 'Add Cadet' },
  '添加老师': { 'en-US': 'Add Teacher' },
  '修改教室': { 'en-US': 'Edit Classroom' },
  '查看教室详情': { 'en-US': 'View Classroom Details' },
  '添加设备': { 'en-US': 'Add Device' },
  '添加课件': { 'en-US': 'Add Courseware' },
  '编辑课件': { 'en-US': 'Edit Courseware' },
  '编辑课包': { 'en-US': 'Edit Package' },
  '添加课包': { 'en-US': 'Add Package' },
  '修改课件分类': { 'en-US': 'Edit Courseware Category' },
  '修改课包分类': { 'en-US': 'Edit Package Category' },
  '修改一级分类': { 'en-US': 'Edit Level 1 Category' },
  '修改二级分类': { 'en-US': 'Edit Level 2 Category' },
  '快捷面板': { 'en-US': 'Quick Panel' },
  '最低版本': { 'en-US': 'Minimum Version' },
  '非选中图标': { 'en-US': 'Unselected Icon' },
  '选中图标': { 'en-US': 'Selected Icon' },
  '未选中图标': { 'en-US': 'Unselected Icon' },
  '配置': { 'en-US': 'Configured' },
  '未配置': { 'en-US': 'Not Configured' },
  '不配置': { 'en-US': 'Not Configured' },
  '简介': { 'en-US': 'Description' },
  '分类': { 'en-US': 'Category' },
  '功能配置JSON': { 'en-US': 'Feature Config JSON' },
  '路由名称': { 'en-US': 'Route Name' },
  '路由地址': { 'en-US': 'Route Path' },
  '路由参数': { 'en-US': 'Route Params' },
  '选择是外链则路由地址需要以`http(s)://`开头': { 'en-US': 'If External Link is Yes, the route path must start with `http(s)://`' },
  '选择是则会被`keep-alive`缓存，需要匹配组件的`name`和地址保持一致': { 'en-US': 'If Yes, it will be cached by `keep-alive`; the component `name` must match the path.' },
  '选择隐藏则路由将不会出现在侧边栏，但仍然可以访问': { 'en-US': 'If Hidden, the route will not appear in the sidebar but can still be accessed.' },
  '选择停用则路由将不会出现在侧边栏，也不能被访问': { 'en-US': 'If Disabled, the route will not appear in the sidebar and cannot be accessed.' },
  '用于菜单国际化的稳定业务Key，如：system.user；为空时使用菜单名称': { 'en-US': 'Stable business key for menu i18n, such as system.user; menu name is used when empty.' },
  '默认不填则和路由地址相同：如地址为：`user`，则名称为`User`（注意：因为router会删除名称相同路由，为避免名字的冲突，特殊情况下请自定义，保证唯一性）': { 'en-US': 'Defaults to the route path when empty. For example, path `user` becomes `User`. Customize it when needed to keep route names unique.' },
  '访问的路由地址，如：`user`，如外网地址需内链访问则以`http(s)://`开头': { 'en-US': 'Route path, for example `user`. External URLs opened internally must start with `http(s)://`.' },
  '访问的组件路径，如：`system/user/index`，默认在`views`目录下': { 'en-US': 'Component path, such as `system/user/index`; defaults under the `views` directory.' },
  '控制器中定义的权限字符，如：@PreAuthorize 权限示例': { 'en-US': 'Permission string defined in the controller, such as a @PreAuthorize expression.' },
  "控制器中定义的权限字符，如：@PreAuthorize(`@ss.hasPermi('system:user:list')`)": { 'en-US': "Permission string defined in the controller, such as @PreAuthorize(`@ss.hasPermi('system:user:list')`)." },
  '访问路由的默认传递参数，如：`{"id": 1, "name": "ry"}`': { 'en-US': 'Default route params, such as `{"id": 1, "name": "ry"}`.' },
  '以下机构显示，其余机构不显示': { 'en-US': 'Show for selected organizations, hide for others' },
  '以下机构不显示，其余机构显示': { 'en-US': 'Hide for selected organizations, show for others' },
  '设置机构': { 'en-US': 'Set Organizations' },
  '设置类型：': { 'en-US': 'Setting Type:' },
  '课件列表可以拖拽排序': { 'en-US': 'Courseware list can be sorted by dragging' },
  '非必填项，可选择多个课件进行关联': { 'en-US': 'Optional. Multiple courseware items can be selected.' },
  '获取详情失败': { 'en-US': 'Failed to get details' },
  '提交': { 'en-US': 'Submit' },
  '筛选': { 'en-US': 'Filter' },
  '至': { 'en-US': 'to' },
  '全选/全不选': { 'en-US': 'Select All / Deselect All' },
  '父子联动': { 'en-US': 'Parent-Child Linkage' },
  '刷新缓存': { 'en-US': 'Refresh Cache' },
  '显示顺序': { 'en-US': 'Display Order' },
  '更新时间': { 'en-US': 'Updated At' },
  '有效期': { 'en-US': 'Valid Period' },
  '将文件拖到此处，或': { 'en-US': 'Drag files here, or ' },
  '点击上传': { 'en-US': 'Click to Upload' },
  '仅允许导入xls、xlsx格式文件。': { 'en-US': 'Only xls and xlsx files are allowed.' },
  '仅支持 .xlsx / .xls 格式文件': { 'en-US': 'Only .xlsx / .xls files are supported' },
  '选中状态图标': { 'en-US': 'Selected State Icon' },
  '未选中状态图标': { 'en-US': 'Unselected State Icon' },
  '未选中图片': { 'en-US': 'Unselected Image' },
  '选中图片': { 'en-US': 'Selected Image' },
  '课件ID': { 'en-US': 'Courseware ID' },
  '课包ID': { 'en-US': 'Package ID' },
  '课件简介': { 'en-US': 'Courseware Description' },
  '课包简介': { 'en-US': 'Package Description' },
  '课件封面': { 'en-US': 'Courseware Cover' },
  '课包封面': { 'en-US': 'Package Cover' },
  '课件内容': { 'en-US': 'Courseware Content' },
  '课程头图': { 'en-US': 'Course Header Image' },
  '课程详情图': { 'en-US': 'Course Detail Image' },
  '实操演示': { 'en-US': 'Practical Demo' },
  '高级配置': { 'en-US': 'Advanced Settings' },
  '配置课件AI功能模版': { 'en-US': 'Configure Courseware AI Feature Template' },
  '关联其他课件ID': { 'en-US': 'Linked Other Courseware IDs' },
  '课件副标题': { 'en-US': 'Courseware Subtitle' },
  '课件类型': { 'en-US': 'Courseware Type' },
  '课包数量': { 'en-US': 'Package Count' },
  '课包状态': { 'en-US': 'Package Status' },
  '课件状态': { 'en-US': 'Courseware Status' },
  '课件介绍': { 'en-US': 'Courseware Description' },
  '课包介绍': { 'en-US': 'Package Description' },
  '课件分类名称': { 'en-US': 'Courseware Category Name' },
  '课包分类名称': { 'en-US': 'Package Category Name' },
  '关联应用名称·状态': { 'en-US': 'Linked Application / Status' },
  '保存时间': { 'en-US': 'Saved At' },
  '作品': { 'en-US': 'Work' },
  '作品ID': { 'en-US': 'Work ID' },
  '作品类型': { 'en-US': 'Work Type' },
  '预览': { 'en-US': 'Preview' },
  '岗位编号': { 'en-US': 'Post ID' },
  '岗位编码': { 'en-US': 'Post Code' },
  '岗位名称': { 'en-US': 'Post Name' },
  '岗位排序': { 'en-US': 'Post Order' },
  '创建者': { 'en-US': 'Created By' },
  '描述': { 'en-US': 'Description' },
  '参数主键': { 'en-US': 'Parameter ID' },
  '系统内置': { 'en-US': 'Built-in' },
  '日志编号': { 'en-US': 'Log ID' },
  '系统模块': { 'en-US': 'System Module' },
  '操作类型': { 'en-US': 'Operation Type' },
  '操作人员': { 'en-US': 'Operator' },
  '操作地址': { 'en-US': 'Operation IP' },
  '操作状态': { 'en-US': 'Operation Status' },
  '操作日期': { 'en-US': 'Operation Date' },
  '消耗时间': { 'en-US': 'Elapsed Time' },
  '访问编号': { 'en-US': 'Access ID' },
  '操作系统': { 'en-US': 'OS' },
  '浏览器': { 'en-US': 'Browser' },
  '访问时间': { 'en-US': 'Access Time' },
  '任务编号': { 'en-US': 'Job ID' },
  '任务名称': { 'en-US': 'Job Name' },
  '任务组名': { 'en-US': 'Job Group' },
  '调用目标字符串': { 'en-US': 'Invoke Target' },
  'cron执行表达式': { 'en-US': 'Cron Expression' },
  '日志信息': { 'en-US': 'Log Message' },
  '执行状态': { 'en-US': 'Execution Status' },
  '执行时间': { 'en-US': 'Execution Time' },
  '表名称': { 'en-US': 'Table Name' },
  '表描述': { 'en-US': 'Table Description' },
  '实体': { 'en-US': 'Entity' },
  '字段列名': { 'en-US': 'Column Name' },
  '字段描述': { 'en-US': 'Column Description' },
  '物理类型': { 'en-US': 'Physical Type' },
  'Java类型': { 'en-US': 'Java Type' },
  'java属性': { 'en-US': 'Java Property' },
  '插入': { 'en-US': 'Insert' },
  '查询方式': { 'en-US': 'Query Type' },
  '必填': { 'en-US': 'Required' },
  '显示类型': { 'en-US': 'Display Type' },
  '会话编号': { 'en-US': 'Session ID' },
  '登录名称': { 'en-US': 'Login Name' },
  '所属部门': { 'en-US': 'Department' },
  '主机': { 'en-US': 'Host' },
  '缓存名称': { 'en-US': 'Cache Name' },
  '缓存键名': { 'en-US': 'Cache Key' },
  '音乐名': { 'en-US': 'Music Name' },
  '音效名': { 'en-US': 'Sound Effect Name' },
  '文件名': { 'en-US': 'File Name' },
  '时长': { 'en-US': 'Duration' },
  '音乐状态': { 'en-US': 'Music Status' },
  '音效状态': { 'en-US': 'Sound Effect Status' },
  '手机': { 'en-US': 'Mobile' },
  '字典状态': { 'en-US': 'Dictionary Status' },
  '创建人': { 'en-US': 'Created By' },
  '更新人': { 'en-US': 'Updated By' },
  '操作人': { 'en-US': 'Operator' },
  '试听': { 'en-US': 'Preview' },
  '音乐': { 'en-US': 'Music' },
  '音乐ID': { 'en-US': 'Music ID' },
  '音乐名称': { 'en-US': 'Music Name' },
  '音乐分类': { 'en-US': 'Music Category' },
  '音乐文件': { 'en-US': 'Music File' },
  '音效ID': { 'en-US': 'Sound Effect ID' },
  '音效名称': { 'en-US': 'Sound Effect Name' },
  '音效分类': { 'en-US': 'Sound Effect Category' },
  '音效文件': { 'en-US': 'Sound Effect File' },
  '封面图展示': { 'en-US': 'Cover Preview' },
  '跳转地址': { 'en-US': 'Jump URL' },
  '请在这里填写跳转页面链接': { 'en-US': 'Enter the target page link here' },
  '请简单介绍描述一下': { 'en-US': 'Please provide a brief description' },
  '请输入': { 'en-US': 'Please enter' },
  '请选择': { 'en-US': 'Please select' },
  '请选择语种': { 'en-US': 'Please select language' },
  '添加': { 'en-US': 'Add' },
  '已添加': { 'en-US': 'Added' },
  '关联': { 'en-US': 'Link' },
  '已关联': { 'en-US': 'Linked' },
  '仅支持上传1个文件': { 'en-US': 'Only one file can be uploaded' },
  '请上传 图片大小不超过 5MB，格式为 png/jpg 的文件，仅上传1个文件，尺寸为333×333': { 'en-US': 'Please upload an image up to 5MB in PNG/JPG format, only one file allowed, dimensions 333×333' },
  '提 交': { 'en-US': 'Submit' },
  '关 闭': { 'en-US': 'Close' },
  '清空': { 'en-US': 'Clear' },
  '清除归属': { 'en-US': 'Clear Assignment' },
  '同步': { 'en-US': 'Sync' },
  '刷新': { 'en-US': 'Refresh' },
  '解锁': { 'en-US': 'Unlock' },
  '强退': { 'en-US': 'Force Logout' },
  '执行一次': { 'en-US': 'Run Once' },
  '立即执行': { 'en-US': 'Run Now' },
  '放弃执行': { 'en-US': 'Cancel Execution' },
  '生成': { 'en-US': 'Generate' },
  '创建': { 'en-US': 'Create' },
  '导入表': { 'en-US': 'Import Table' },
  '创建表': { 'en-US': 'Create Table' },
  '导出vue文件': { 'en-US': 'Export Vue File' },
  '复制代码': { 'en-US': 'Copy Code' },
  '增加': { 'en-US': 'Add' },
  '增加数量': { 'en-US': 'Add Quantity' },
  '复制': { 'en-US': 'Copy' },
  '取消授权': { 'en-US': 'Revoke' },
  '批量取消授权': { 'en-US': 'Batch Revoke' },
  '批量导入': { 'en-US': 'Batch Import' },
  '展示全路径': { 'en-US': 'Show Full Path' },
  '更换头像': { 'en-US': 'Change Avatar' },
  '打印': { 'en-US': 'Print' },
  '返回': { 'en-US': 'Back' },
  '详细': { 'en-US': 'Details' },
  '内容': { 'en-US': 'Content' },
  '图片': { 'en-US': 'Image' },
  '视频': { 'en-US': 'Video' },
  '音频': { 'en-US': 'Audio' },
  '默认': { 'en-US': 'Default' },
  '默认值': { 'en-US': 'Default Value' },
  '禁止': { 'en-US': 'Disabled' },
  '允许': { 'en-US': 'Allowed' },
  '选择': { 'en-US': 'Select' },
  '选项': { 'en-US': 'Options' },
  '选项值': { 'en-US': 'Option Value' },
  '选项名': { 'en-US': 'Option Name' },
  '选项分隔符': { 'en-US': 'Option Separator' },
  '选项尺寸': { 'en-US': 'Option Size' },
  '选项样式': { 'en-US': 'Option Style' },
  '辅助文字': { 'en-US': 'Helper Text' },
  '输入统计': { 'en-US': 'Input Counter' },
  '前缀': { 'en-US': 'Prefix' },
  '后缀': { 'en-US': 'Suffix' },
  '前图标': { 'en-US': 'Prefix Icon' },
  '后图标': { 'en-US': 'Suffix Icon' },
  '基本信息': { 'en-US': 'Basic Info' },
  '基本资料': { 'en-US': 'Basic Info' },
  '生成信息': { 'en-US': 'Generation Info' },
  '字段信息': { 'en-US': 'Field Info' },
  '布局大小': { 'en-US': 'Layout Size' },
  '布局结构树': { 'en-US': 'Layout Tree' },
  '组件名': { 'en-US': 'Component Name' },
  '组件类型': { 'en-US': 'Component Type' },
  '组件属性': { 'en-US': 'Component Properties' },
  '组件宽度': { 'en-US': 'Component Width' },
  '表单名': { 'en-US': 'Form Name' },
  '表单尺寸': { 'en-US': 'Form Size' },
  '表单属性': { 'en-US': 'Form Properties' },
  '表单按钮': { 'en-US': 'Form Buttons' },
  '表单栅格': { 'en-US': 'Form Layout' },
  '表单模型': { 'en-US': 'Form Model' },
  '禁用表单': { 'en-US': 'Disable Form' },
  '校验模型': { 'en-US': 'Validation Model' },
  '正则校验': { 'en-US': 'Regex Validation' },
  '是否必填': { 'en-US': 'Required' },
  '是否禁用': { 'en-US': 'Disabled' },
  '是否只读': { 'en-US': 'Read Only' },
  '是否多选': { 'en-US': 'Multiple' },
  '是否带边框': { 'en-US': 'Bordered' },
  '是否可搜索': { 'en-US': 'Searchable' },
  '能否清空': { 'en-US': 'Clearable' },
  '可否筛选': { 'en-US': 'Filterable' },
  '允许半选': { 'en-US': 'Allow Half Check' },
  '可多选': { 'en-US': 'Multiple' },
  '可多选文件': { 'en-US': 'Multiple Files' },
  '多选文件': { 'en-US': 'Multiple Files' },
  '自动上传': { 'en-US': 'Auto Upload' },
  '显示分数': { 'en-US': 'Show Score' },
  '显示提示': { 'en-US': 'Show Tooltip' },
  '显示间断点': { 'en-US': 'Show Stops' },
  '显示未选中组件边框': { 'en-US': 'Show Border When Unselected' },
  '显隐列': { 'en-US': 'Toggle Columns' },
  '标签宽度': { 'en-US': 'Label Width' },
  '标签对齐': { 'en-US': 'Label Align' },
  '标签键名': { 'en-US': 'Label Key' },
  '值键名': { 'en-US': 'Value Key' },
  '子级键名': { 'en-US': 'Children Key' },
  '步数': { 'en-US': 'Step Count' },
  '步长': { 'en-US': 'Step' },
  '精度': { 'en-US': 'Precision' },
  '最大值': { 'en-US': 'Max' },
  '最小值': { 'en-US': 'Min' },
  '最大行数': { 'en-US': 'Max Rows' },
  '最小行数': { 'en-US': 'Min Rows' },
  '最多输入': { 'en-US': 'Max Length' },
  '最多可选': { 'en-US': 'Max Selectable' },
  '至少应选': { 'en-US': 'Min Selectable' },
  '范围选择': { 'en-US': 'Range Select' },
  '颜色格式': { 'en-US': 'Color Format' },
  '回显样式': { 'en-US': 'Display Style' },
  '样式属性': { 'en-US': 'Style Properties' },
  '占位提示': { 'en-US': 'Placeholder' },
  '开始占位': { 'en-US': 'Start Placeholder' },
  '结束占位': { 'en-US': 'End Placeholder' },
  '错误提示': { 'en-US': 'Error Tip' },
  '开启提示': { 'en-US': 'Open Tip' },
  '关闭提示': { 'en-US': 'Close Tip' },
  '开启值': { 'en-US': 'On Value' },
  '关闭值': { 'en-US': 'Off Value' },
  '开启颜色': { 'en-US': 'On Color' },
  '关闭颜色': { 'en-US': 'Off Color' },
  '按钮文字': { 'en-US': 'Button Text' },
  '按钮位置': { 'en-US': 'Button Position' },
  '左对齐': { 'en-US': 'Left Align' },
  '右对齐': { 'en-US': 'Right Align' },
  '顶部对齐': { 'en-US': 'Top Align' },
  '水平排列': { 'en-US': 'Horizontal' },
  '垂直排列': { 'en-US': 'Vertical' },
  '右侧': { 'en-US': 'Right' },
  '动态数据': { 'en-US': 'Dynamic Data' },
  '静态数据': { 'en-US': 'Static Data' },
  '栅格间隔': { 'en-US': 'Gutter' },
  '时间格式': { 'en-US': 'Time Format' },
  '时间段': { 'en-US': 'Time Range' },
  '时间类型': { 'en-US': 'Time Type' },
  '日期控件': { 'en-US': 'Date Picker' },
  '日期时间': { 'en-US': 'Date Time' },
  '文本框': { 'en-US': 'Input' },
  '文本域': { 'en-US': 'Textarea' },
  '下拉框': { 'en-US': 'Select' },
  '单选框': { 'en-US': 'Radio' },
  '复选框': { 'en-US': 'Checkbox' },
  '富文本控件': { 'en-US': 'Rich Text' },
  '文件上传': { 'en-US': 'File Upload' },
  '图片上传': { 'en-US': 'Image Upload' },
  '文件大小': { 'en-US': 'File Size' },
  '文件类型': { 'en-US': 'File Type' },
  '文件字段名': { 'en-US': 'File Field Name' },
  '文档地址': { 'en-US': 'Document URL' },
  '上传地址': { 'en-US': 'Upload URL' },
  '图片地址': { 'en-US': 'Image URL' },
  '链接输入': { 'en-US': 'Link Input' },
  '链接输入：': { 'en-US': 'Link Input:' },
  '配置输入': { 'en-US': 'Config Input' },
  '配置输入：': { 'en-US': 'Config Input:' },
  '重新上传': { 'en-US': 'Reupload' },
  '选取文件': { 'en-US': 'Select File' },
  '点击选择图标': { 'en-US': 'Click to Select Icon' },
  '请输入正则': { 'en-US': 'Please enter regex' },
  '正则': { 'en-US': 'Regex' },
  '分隔符': { 'en-US': 'Separator' },
  '较大': { 'en-US': 'Large' },
  '较小': { 'en-US': 'Small' },
  '主题模式': { 'en-US': 'Theme Mode' },
  '严格步数': { 'en-US': 'Strict Step' },
  '秒': { 'en-US': 'Second' },
  '分钟': { 'en-US': 'Minute' },
  '小时': { 'en-US': 'Hour' },
  '日': { 'en-US': 'Day' },
  '月': { 'en-US': 'Month' },
  '周': { 'en-US': 'Week' },
  '年': { 'en-US': 'Year' },
  '每年': { 'en-US': 'Every Year' },
  '本月最后一天': { 'en-US': 'Last Day of Month' },
  '不指定': { 'en-US': 'Not Specified' },
  '表达式': { 'en-US': 'Expression' },
  'cron表达式': { 'en-US': 'Cron Expression' },
  'cron表达式：': { 'en-US': 'Cron Expression:' },
  '姓名：': { 'en-US': 'Name:' },
  '昵称': { 'en-US': 'Nickname' },
  '头像': { 'en-US': 'Avatar' },
  '性别': { 'en-US': 'Gender' },
  '性别：': { 'en-US': 'Gender:' },
  '年龄': { 'en-US': 'Age' },
  '年龄：': { 'en-US': 'Age:' },
  '电话：': { 'en-US': 'Phone:' },
  '微信：': { 'en-US': 'WeChat:' },
  '微信号': { 'en-US': 'WeChat ID' },
  '微信账号': { 'en-US': 'WeChat Account' },
  '微信账号：': { 'en-US': 'WeChat Account:' },
  '邮箱：': { 'en-US': 'Email:' },
  '密码': { 'en-US': 'Password' },
  '密码：': { 'en-US': 'Password:' },
  '旧密码': { 'en-US': 'Old Password' },
  '新密码密码': { 'en-US': 'New Password' },
  '确认密码': { 'en-US': 'Confirm Password' },
  '请确认新密码': { 'en-US': 'Please confirm the new password' },
  '请再次输入新密码': { 'en-US': 'Please re-enter the new password' },
  '男': { 'en-US': 'Male' },
  '女': { 'en-US': 'Female' },
  '身份': { 'en-US': 'Identity' },
  '负责人': { 'en-US': 'Owner' },
  '岗位': { 'en-US': 'Position' },
  '岗位状态': { 'en-US': 'Position Status' },
  '岗位顺序': { 'en-US': 'Position Order' },
  '部门': { 'en-US': 'Department' },
  '部门名称': { 'en-US': 'Department Name' },
  '部门状态': { 'en-US': 'Department Status' },
  '上级部门': { 'en-US': 'Parent Department' },
  '归属部门': { 'en-US': 'Department' },
  '联系电话': { 'en-US': 'Contact Phone' },
  '职位：': { 'en-US': 'Position:' },
  '账号：': { 'en-US': 'Account:' },
  '账号状态：': { 'en-US': 'Account Status:' },
  '账号管理': { 'en-US': 'Account Management' },
  '登录账号：': { 'en-US': 'Login Account:' },
  '登录信息：': { 'en-US': 'Login Info:' },
  '创建教室': { 'en-US': 'Create Classroom' },
  '选择教室': { 'en-US': 'Select Classroom' },
  '请选择教室': { 'en-US': 'Please select classroom' },
  '选择成员': { 'en-US': 'Select Member' },
  '添加教室成员': { 'en-US': 'Add Classroom Member' },
  '选择设备': { 'en-US': 'Select Device' },
  '设备数量': { 'en-US': 'Device Count' },
  '资产码': { 'en-US': 'Asset No.' },
  '型号': { 'en-US': 'Model' },
  '座位号': { 'en-US': 'Seat No.' },
  '请输入座位号': { 'en-US': 'Please enter seat number' },
  '房间号': { 'en-US': 'Room No.' },
  '请输入房间号': { 'en-US': 'Please enter room number' },
  '房间ID': { 'en-US': 'Room ID' },
  '该时段所有课程': { 'en-US': 'All courses in this period' },
  '请选择课包分类': { 'en-US': 'Please select package category' },
  '请输入学员姓名': { 'en-US': 'Please enter cadet name' },
  '请输入学员学号': { 'en-US': 'Please enter cadet student ID' },
  '请输入学员年龄': { 'en-US': 'Please enter cadet age' },
  '请输入学员微信': { 'en-US': 'Please enter cadet WeChat' },
  '请输入学员电话': { 'en-US': 'Please enter cadet phone' },
  '请输入老师姓名': { 'en-US': 'Please enter teacher name' },
  '请输入老师工号': { 'en-US': 'Please enter teacher staff ID' },
  '请输入老师微信': { 'en-US': 'Please enter teacher WeChat' },
  '请输入老师电话': { 'en-US': 'Please enter teacher phone' },
  '请输入老师手机号': { 'en-US': 'Please enter teacher phone number' },
  '请输入老师邮箱': { 'en-US': 'Please enter teacher email' },
  '老师姓名': { 'en-US': 'Teacher Name' },
  '老师姓名：': { 'en-US': 'Teacher Name:' },
  '老师工号': { 'en-US': 'Teacher Staff ID' },
  '老师微信': { 'en-US': 'Teacher WeChat' },
  '老师电话': { 'en-US': 'Teacher Phone' },
  '老师手机号': { 'en-US': 'Teacher Phone' },
  '老师邮箱': { 'en-US': 'Teacher Email' },
  '老师邮箱：': { 'en-US': 'Teacher Email:' },
  '老师账号': { 'en-US': 'Teacher Account' },
  '编辑老师信息': { 'en-US': 'Edit Teacher' },
  '老师基本信息': { 'en-US': 'Teacher Profile' },
  '当堂老师': { 'en-US': 'Current Teacher' },
  '请选择成员身份': { 'en-US': 'Please select member role' },
  '工号/学号': { 'en-US': 'Staff/Student ID' },
  '学员ID：': { 'en-US': 'Cadet ID:' },
  '学员号': { 'en-US': 'Cadet ID' },
  '学员姓名：': { 'en-US': 'Cadet Name:' },
  '学员学号': { 'en-US': 'Cadet Student ID' },
  '学员身份：': { 'en-US': 'Cadet Identity:' },
  '学号：': { 'en-US': 'Student ID:' },
  '学生号': { 'en-US': 'Student ID' },
  '学生号：': { 'en-US': 'Student ID:' },
  '人数': { 'en-US': 'Count' },
  '课件封面图': { 'en-US': 'Courseware Cover Image' },
  '课包封面图': { 'en-US': 'Package Cover Image' },
  '课程标题': { 'en-US': 'Course Title' },
  '课程信息': { 'en-US': 'Course Info' },
  '课程id': { 'en-US': 'Course ID' },
  '课程时长（小时）': { 'en-US': 'Course Duration (hours)' },
  '课件异常': { 'en-US': 'Courseware Abnormal' },
  '课件内容AI功能配置模版': { 'en-US': 'Courseware AI Feature Template' },
  '课堂文件数量': { 'en-US': 'Class File Count' },
  '调度日志': { 'en-US': 'Scheduling Logs' },
  '调度日志详细': { 'en-US': 'Scheduling Log Detail' },
  '调用方法：': { 'en-US': 'Invoke Method:' },
  '调用目标方法：': { 'en-US': 'Invoke Target Method:' },
  '请输入课件名称': { 'en-US': 'Please enter courseware name' },
  '请输入课件副标题': { 'en-US': 'Please enter courseware subtitle' },
  '请输入课件介绍': { 'en-US': 'Please enter courseware description' },
  '请输入课件分类名称': { 'en-US': 'Please enter courseware category name' },
  '请输入课包名称': { 'en-US': 'Please enter package name' },
  '请输入课包介绍': { 'en-US': 'Please enter package description' },
  '请输入课包分类名称': { 'en-US': 'Please enter package category name' },
  '请选择要关联的课件': { 'en-US': 'Please select related courseware' },
  '请选择设备序列号': { 'en-US': 'Please select device serial number' },
  '请选择一级分类': { 'en-US': 'Please select level 1 category' },
  '请输入一级分类名称': { 'en-US': 'Please enter level 1 category name' },
  '请输入二级分类名称': { 'en-US': 'Please enter level 2 category name' },
  '应用名称：': { 'en-US': 'Application Name:' },
  '应用介绍：': { 'en-US': 'Application Description:' },
  '应用分类：': { 'en-US': 'Application Category:' },
  '应用封面图：': { 'en-US': 'Application Cover:' },
  '应用状态：': { 'en-US': 'Application Status:' },
  '应用类型：': { 'en-US': 'Application Type:' },
  '请输入应用名称': { 'en-US': 'Please enter application name' },
  '请输入应用介绍': { 'en-US': 'Please enter application description' },
  '请输入发布时间': { 'en-US': 'Please enter publish time' },
  '请选择发布时间': { 'en-US': 'Please select publish time' },
  '请输入0 定时发布 1 立即发布': { 'en-US': 'Please enter 0 for scheduled and 1 for immediate publish' },
  '请输入具体链接': { 'en-US': 'Please enter the link' },
  '机构ID：': { 'en-US': 'Institution ID:' },
  '机构名称：': { 'en-US': 'Institution Name:' },
  '机构邮箱：': { 'en-US': 'Institution Email:' },
  '机构类型：': { 'en-US': 'Institution Type:' },
  '机构负责人姓名': { 'en-US': 'Institution Owner Name' },
  '所属机构：': { 'en-US': 'Organization:' },
  '请输入机构名称': { 'en-US': 'Please enter institution name' },
  '请输入机构ID': { 'en-US': 'Please enter institution ID' },
  '请输入机构邮箱': { 'en-US': 'Please enter institution email' },
  '请输入负责人': { 'en-US': 'Please enter owner' },
  '请输入负责人姓名': { 'en-US': 'Please enter owner name' },
  '请输入负责人微信': { 'en-US': 'Please enter owner WeChat' },
  '请输入负责人电话': { 'en-US': 'Please enter owner phone' },
  '请输入负责人职位': { 'en-US': 'Please enter owner position' },
  '请输入负责人邮箱': { 'en-US': 'Please enter owner email' },
  '上传图片大小不超过 2MB': { 'en-US': 'Image must be smaller than 2MB' },
  '支持 jpg / png，不超过 2MB': { 'en-US': 'Supports jpg/png, up to 2MB' },
  '请上传1张1寸免冠证件照': { 'en-US': 'Please upload a 1-inch ID photo' },
  '只能上传MP3格式音频，且不超过500kb': { 'en-US': 'Only MP3 audio under 500KB allowed' },
  '最多上传 70 个文件': { 'en-US': 'Up to 70 files' },
  '最多上传5个文件, 图片尺寸：1344×756': { 'en-US': 'Up to 5 files, size 1344×756' },
  '仅上传1个文件，尺寸为320×130': { 'en-US': 'Only 1 file, size 320×130' },
  '仅上传1个文件，尺寸为333×333': { 'en-US': 'Only 1 file, size 333×333' },
  '仅上传1个文件，尺寸为333×333 ': { 'en-US': 'Only 1 file, size 333×333 ' },
  '仅上传1个文件，尺寸为1387×493': { 'en-US': 'Only 1 file, size 1387×493' },
  '如 1.0.0，低于此版本的客户端不展示该功能': { 'en-US': 'e.g. 1.0.0; clients below this version will not see this feature' },
  'AIGC课程': { 'en-US': 'AIGC Course' },
  '2024年1期4班': { 'en-US': '2024 Term 1 Class 4' },
  '203课室': { 'en-US': 'Room 203' },
  '206教室': { 'en-US': 'Room 206' },
  '蒋陈子老师': { 'en-US': 'Teacher Jiang Chenzi' },
  '王菲老师': { 'en-US': 'Teacher Wang Fei' },
  '简介描述': { 'en-US': 'Description' },
  '功能简介': { 'en-US': 'Feature Description' },
  '请输入JSON或者API': { 'en-US': 'Please enter JSON or API' },
  '请输入JSON配置': { 'en-US': 'Please enter JSON config' },
  '请输入功能模版，建议JSON格式': { 'en-US': 'Please enter feature template, JSON suggested' },
  '请输入内容配置，建议JSON格式': { 'en-US': 'Please enter content config, JSON suggested' },
  '请输入扩展数据': { 'en-US': 'Please enter extension data' },
  '请输入数据内容': { 'en-US': 'Please enter data content' },
  '请输入数据模型': { 'en-US': 'Please enter data model' },
  '请输入校验模型': { 'en-US': 'Please enter validation model' },
  '请输入样式属性': { 'en-US': 'Please enter style attributes' },
  '请输入字符长度': { 'en-US': 'Please enter character length' },
  '请输入字段名（v-model）': { 'en-US': 'Please enter field name (v-model)' },
  '请输入表单名（ref）': { 'en-US': 'Please enter form name (ref)' },
  '任务编号：': { 'en-US': 'Job ID:' },
  '任务名称：': { 'en-US': 'Job Name:' },
  '任务分组': { 'en-US': 'Job Group' },
  '任务分组：': { 'en-US': 'Job Group:' },
  '任务状态': { 'en-US': 'Job Status' },
  '任务状态：': { 'en-US': 'Job Status:' },
  '任务详细': { 'en-US': 'Job Details' },
  '执行策略': { 'en-US': 'Misfire Policy' },
  '执行策略：': { 'en-US': 'Misfire Policy:' },
  '执行状态：': { 'en-US': 'Execution Status:' },
  '执行时间：': { 'en-US': 'Execution Time:' },
  '是否并发': { 'en-US': 'Concurrent' },
  '是否并发：': { 'en-US': 'Concurrent:' },
  '下次执行时间：': { 'en-US': 'Next Run Time:' },
  '日志信息：': { 'en-US': 'Log Message:' },
  '日志序号：': { 'en-US': 'Log ID:' },
  '异常信息：': { 'en-US': 'Exception:' },
  '消耗时间：': { 'en-US': 'Elapsed Time:' },
  '操作模块：': { 'en-US': 'Operation Module:' },
  '操作日志详细': { 'en-US': 'Operation Log Details' },
  '操作时间：': { 'en-US': 'Operation Time:' },
  '操作方法：': { 'en-US': 'Operation Method:' },
  '操作状态：': { 'en-US': 'Operation Status:' },
  '请求地址：': { 'en-US': 'Request URL:' },
  '请求方式：': { 'en-US': 'Request Method:' },
  '请求参数：': { 'en-US': 'Request Params:' },
  '返回参数：': { 'en-US': 'Response Params:' },
  '缓存名称:': { 'en-US': 'Cache Name:' },
  '缓存键名:': { 'en-US': 'Cache Key:' },
  '缓存内容:': { 'en-US': 'Cache Content:' },
  '请输入任务名称': { 'en-US': 'Please enter job name' },
  '请输入操作人员': { 'en-US': 'Please enter operator' },
  '请输入操作地址': { 'en-US': 'Please enter operation IP' },
  '请输入登录地址': { 'en-US': 'Please enter login IP' },
  '请输入系统模块': { 'en-US': 'Please enter system module' },
  '请输入cron执行表达式': { 'en-US': 'Please enter cron expression' },
  '请输入调用目标字符串': { 'en-US': 'Please enter invoke target' },
  '请选择任务状态': { 'en-US': 'Please select job status' },
  '请选择任务组名': { 'en-US': 'Please select job group' },
  '请选择执行状态': { 'en-US': 'Please select execution status' },
  '字典编号': { 'en-US': 'Dictionary ID' },
  '请输入字典名称': { 'en-US': 'Please enter dictionary name' },
  '请输入字典类型': { 'en-US': 'Please enter dictionary type' },
  '请输入字典标签': { 'en-US': 'Please enter dictionary label' },
  '数据标签': { 'en-US': 'Data Label' },
  '数据状态': { 'en-US': 'Data Status' },
  '数据类型': { 'en-US': 'Data Type' },
  '数据键值': { 'en-US': 'Data Value' },
  '请输入数据标签': { 'en-US': 'Please enter data label' },
  '请输入数据键值': { 'en-US': 'Please enter data value' },
  '请输入参数名称': { 'en-US': 'Please enter parameter name' },
  '请输入参数键名': { 'en-US': 'Please enter parameter key' },
  '请输入参数键值': { 'en-US': 'Please enter parameter value' },
  '请输入岗位名称': { 'en-US': 'Please enter position name' },
  '请输入岗位编码': { 'en-US': 'Please enter position code' },
  '请输入编码名称': { 'en-US': 'Please enter code name' },
  '请输入用户名称': { 'en-US': 'Please enter username' },
  '请输入用户密码': { 'en-US': 'Please enter password' },
  '请输入用户昵称': { 'en-US': 'Please enter nickname' },
  '请输入角色名称': { 'en-US': 'Please enter role name' },
  '请输入菜单名称': { 'en-US': 'Please enter menu name' },
  '请输入菜单国际化Key': { 'en-US': 'Please enter menu i18n key' },
  '请输入路由名称': { 'en-US': 'Please enter route name' },
  '请输入路由地址': { 'en-US': 'Please enter route path' },
  '请输入路由参数': { 'en-US': 'Please enter route params' },
  '请输入组件路径': { 'en-US': 'Please enter component path' },
  '请输入权限标识': { 'en-US': 'Please enter permission identifier' },
  '请输入权限字符': { 'en-US': 'Please enter permission string' },
  '请输入图标地址': { 'en-US': 'Please enter icon URL' },
  '请输入图标名称': { 'en-US': 'Please enter icon name' },
  '请输入前图标名称': { 'en-US': 'Please enter prefix icon name' },
  '请输入后图标名称': { 'en-US': 'Please enter suffix icon name' },
  '请输入排序': { 'en-US': 'Please enter sort order' },
  '请输入名称': { 'en-US': 'Please enter name' },
  '请输入标题': { 'en-US': 'Please enter title' },
  '请输入分类名称': { 'en-US': 'Please enter category name' },
  '请输入手机号': { 'en-US': 'Please enter phone number' },
  '请输入手机号码': { 'en-US': 'Please enter mobile number' },
  '请输入邮箱': { 'en-US': 'Please enter email' },
  '请输入账号': { 'en-US': 'Please enter account' },
  '请输入密码': { 'en-US': 'Please enter password' },
  '请输入昵称': { 'en-US': 'Please enter nickname' },
  '请输入旧密码': { 'en-US': 'Please enter old password' },
  '请输入新密码': { 'en-US': 'Please enter new password' },
  '请输入新增算力说明': { 'en-US': 'Please enter credit description' },
  '请输入算力数量': { 'en-US': 'Please enter credit amount' },
  '请输入文件名': { 'en-US': 'Please enter file name' },
  '请输入文件大小': { 'en-US': 'Please enter file size' },
  '请输入选项名': { 'en-US': 'Please enter option name' },
  '请输入选项值': { 'en-US': 'Please enter option value' },
  '请输入选项分隔符': { 'en-US': 'Please enter option separator' },
  '请输入按钮文字': { 'en-US': 'Please enter button text' },
  '请输入分隔符': { 'en-US': 'Please enter separator' },
  '请输入前缀': { 'en-US': 'Please enter prefix' },
  '请输入后缀': { 'en-US': 'Please enter suffix' },
  '请输入开启值': { 'en-US': 'Please enter on value' },
  '请输入关闭值': { 'en-US': 'Please enter off value' },
  '请输入开启提示': { 'en-US': 'Please enter on tip' },
  '请输入关闭提示': { 'en-US': 'Please enter off tip' },
  '请输入错误提示': { 'en-US': 'Please enter error tip' },
  '请输入子级键名': { 'en-US': 'Please enter children key' },
  '请输入值键名': { 'en-US': 'Please enter value key' },
  '请输入标签键名': { 'en-US': 'Please enter label key' },
  '请输入标签宽度': { 'en-US': 'Please enter label width' },
  '请输入组件宽度': { 'en-US': 'Please enter component width' },
  '请输入占位提示': { 'en-US': 'Please enter placeholder' },
  '请输入文本': { 'en-US': 'Please enter text' },
  '请输入内容': { 'en-US': 'Please enter content' },
  '请输入时间格式': { 'en-US': 'Please enter time format' },
  '请输入时间段': { 'en-US': 'Please enter time range' },
  '请输入默认值': { 'en-US': 'Please enter default value' },
  '请输入功能名称': { 'en-US': 'Please enter feature name' },
  '请输入仓库名称': { 'en-US': 'Please enter repository name' },
  '请输入公告标题': { 'en-US': 'Please enter notice title' },
  '请输入教室名称': { 'en-US': 'Please enter classroom name' },
  '请输入音乐名': { 'en-US': 'Please enter music name' },
  '请输入音效名': { 'en-US': 'Please enter sound effect name' },
  '请输入一个简单清晰的标题': { 'en-US': 'Please enter a clear and concise title' },
  '请输入上传地址': { 'en-US': 'Please enter upload URL' },
  '请输入上传文件字段名': { 'en-US': 'Please enter upload field name' },
  '请选择文件类型': { 'en-US': 'Please select file type' },
  '请选择类型': { 'en-US': 'Please select type' },
  '请选择状态': { 'en-US': 'Please select status' },
  '请选择时间类型': { 'en-US': 'Please select time type' },
  '请选择系统菜单': { 'en-US': 'Please select system menu' },
  '请选择组件类型': { 'en-US': 'Please select component type' },
  '请选择水平排列': { 'en-US': 'Please select horizontal layout' },
  '请选择分类状态': { 'en-US': 'Please select category status' },
  '请选择归属部门': { 'en-US': 'Please select department' },
  '请选择颜色格式': { 'en-US': 'Please select color format' },
  '请选择绘画类型': { 'en-US': 'Please select drawing type' },
  '请选择音乐分类': { 'en-US': 'Please select music category' },
  '选择音乐分类': { 'en-US': 'Select Music Category' },
  '选择音效分类': { 'en-US': 'Select Sound Effect Category' },
  '选择上级菜单': { 'en-US': 'Select Parent Menu' },
  '选择上级部门': { 'en-US': 'Select Parent Department' },
  '选择机构类型': { 'en-US': 'Select Institution Type' },
  '选择算力类型': { 'en-US': 'Select Credit Type' },
  '选择课件分类': { 'en-US': 'Select Courseware Category' },
  '选择课包分类': { 'en-US': 'Select Package Category' },
  '选择生成类型': { 'en-US': 'Select Generation Type' },
  '选择时间': { 'en-US': 'Select Time' },
  '选择用户': { 'en-US': 'Select User' },
  '算力类型': { 'en-US': 'Credit Type' },
  '绘画类型': { 'en-US': 'Drawing Type' },
  '菜单权限': { 'en-US': 'Menu Permissions' },
  '权限范围': { 'en-US': 'Permission Scope' },
  '角色：': { 'en-US': 'Role:' },
  '角色状态': { 'en-US': 'Role Status' },
  '配乐文件': { 'en-US': 'Soundtrack File' },
  '个人中心': { 'en-US': 'Profile Center' },
  '个人信息': { 'en-US': 'Profile' },
  '暂无应用': { 'en-US': 'No application' },
  '暂无课件': { 'en-US': 'No courseware' },
  '暂无学员数据': { 'en-US': 'No cadet data' },
  '暂无课堂文件': { 'en-US': 'No class files' },
  '分配归属': { 'en-US': 'Assign Owner' },
}

// Exact-match overrides (special whitespace/punctuation cases).
const exactTextMap: Record<string, Translation> = {
  ...termMap,
  '确 定': { 'en-US': 'Confirm' },
  '取 消': { 'en-US': 'Cancel' },
  '新增/编辑': { 'en-US': 'Add/Edit' },
  '展开/折叠': { 'en-US': 'Expand/Collapse' },
  '回首页': { 'en-US': 'Home' },
  '返回首页': { 'en-US': 'Back Home' },
  '暂无数据': { 'en-US': 'No Data' },
  '暂无': { 'en-US': 'None' },
  '更多': { 'en-US': 'More' },
  '更多菜单': { 'en-US': 'More' },
}

const translateTerm = (value: string, locale: AppLocale): string => {
  const exact = exactTextMap[value]
  if (exact && exact[locale]) return exact[locale] as string
  const term = termMap[value]
  if (term && term[locale]) return term[locale] as string
  return value
}

// Locale-specific fallback rules.  When the source string is not in the
// dictionaries, these patterns translate composite phrases.
const localeRules: Partial<Record<AppLocale, PatternRule[]>> = {
  'en-US': [
    { match: /^(.+)(\uff1a|:)$/, render: t => `${translateTerm(t, 'en-US')}:` },
    { match: /^请输入(.+)$/, render: t => `Please enter ${translateTerm(t, 'en-US')}` },
    { match: /^请选择(.+)$/, render: t => `Please select ${translateTerm(t, 'en-US')}` },
    { match: /^请先选择(.+)$/, render: t => `Please select ${translateTerm(t, 'en-US')} first` },
    { match: /^(.+)不能为空$/, render: t => `${translateTerm(t, 'en-US')} is required` },
    { match: /^(.+)成功$/, render: t => `${translateTerm(t, 'en-US')} successful` },
  ],
}

export const translatePageText = (value: string): string => {
  const locale = getCurrentLocale()
  if (locale === 'zh-CN') {
    return value
  }

  const source = value.trim()
  if (!source) {
    return value
  }

  const exact = exactTextMap[source]?.[locale]
  if (exact) {
    return value.replace(source, exact)
  }

  const rules = localeRules[locale]
  if (rules) {
    for (const rule of rules) {
      const m = source.match(rule.match)
      if (m) {
        return value.replace(source, rule.render(m[1]))
      }
    }
  }

  return value
}
